import * as firebase from "firebase";
// Initialize Firebase
// TODO: Replace with your project's customized code snippet
var config = {
    apiKey: "AIzaSyDTZtE31LbePrZ8Fin_K7Lxwwt58TF1dIg",
    authDomain: "fire-base-hallix.firebaseapp.com",
    databaseURL: "https://fire-base-hallix.firebaseio.com"
  };
  firebase.initializeApp(config);
  
export default firebase;


// WEBPACK FOOTER //
// ./src/firebase.service.js